module.exports = __webpack_public_path__ + "static/fonts/Fact-Narrow.0ce3f00.woff";